import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const SelectIcon: FC<SvgIconProps> = (props) => (
	<SvgIcon {...props}>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15 4.11111C15 5.83 11.8656 7.22222 8 7.22222C4.13444 7.22222 1 5.83 1 4.11111M15 4.11111C15 2.39222 11.8656 1 8 1C4.13444 1 1 2.39222 1 4.11111M15 4.11111V8M1 4.11111V8M15 8C15 9.71889 11.8656 11.1111 8 11.1111C4.13444 11.1111 1 9.71889 1 8M15 8V11.8889C15 13.6078 11.8656 15 8 15C4.13444 15 1 13.6078 1 11.8889V8"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</SvgIcon>
);
